import React, { createContext, useContext, useCallback } from 'react';
import sk from './sk';
import cz from './cz';
import en from './en';

const DICTS = { SK: sk, CZ: cz, EN: en };

// Jazyky + ich cesty (SK je default bez prefixu).
export const LANGS = [
  { code: 'SK', label: 'Slovenčina', short: 'SK', path: '/', htmlLang: 'sk' },
  { code: 'CZ', label: 'Čeština', short: 'CZ', path: '/cz', htmlLang: 'cs' },
  { code: 'EN', label: 'English', short: 'EN', path: '/en', htmlLang: 'en' },
];

export const langByCode = (code) => LANGS.find((l) => l.code === code) || LANGS[0];

/** Cesta na stránku sťahovania v danej mutácii (SK je bez prefixu). */
export const downloadPathFor = (code) => {
  const base = langByCode(code).path;
  return base === '/' ? '/download' : `${base}/download`;
};

const resolve = (dict, key) => {
  const parts = key.split('.');
  let cur = dict;
  for (const p of parts) {
    if (cur && typeof cur === 'object' && p in cur) cur = cur[p];
    else return undefined;
  }
  return cur;
};

const LandingI18nContext = createContext({ lang: 'SK', t: (k) => k });

export const LandingI18nProvider = ({ lang = 'SK', children }) => {
  const dict = DICTS[lang] || sk;
  // t() vráti reťazec ALEBO štruktúru (pole/objekt) — pre zoznamy (FAQ, karty).
  // Fallback: aktuálny jazyk → slovenčina → samotný kľúč.
  const t = useCallback((key) => {
    const v = resolve(dict, key);
    if (v !== undefined) return v;
    const f = resolve(sk, key);
    return f !== undefined ? f : key;
  }, [dict]);
  return (
    <LandingI18nContext.Provider value={{ lang, t }}>
      {children}
    </LandingI18nContext.Provider>
  );
};

export const useT = () => useContext(LandingI18nContext).t;
export const useLang = () => useContext(LandingI18nContext).lang;
